import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { NightowlFormComponent } from '../nightowl-form/nightowl-form.component';
import { EverwatchFormComponent } from '../everwatch-form/everwatch-form.component';
import { BehaviorSubject } from 'rxjs';
import { AddDeviceFormComponent } from '../devices/device-add/add-device-form/add-device-form.component';

@Component({
    selector: 'app-add-device-admin-form',
    templateUrl: './add-device-admin-form.component.html',
    styleUrls: ['./add-device-admin-form.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        CommonModule,
        TranslateModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        FormsModule,
        NightowlFormComponent,
        EverwatchFormComponent,
        AddDeviceFormComponent
    ]
})
export class AddDeviceAdminFormComponent {
  @Output() closeEvent = new EventEmitter<void>();
  @Output() savedEvent = new EventEmitter<string>();

  @Input() locations: { id: string, name: string }[];

  errorMsg$ = new BehaviorSubject<string>("");
  informationMsg$ = new BehaviorSubject<string>("");

  selectedDeviceType: "everon-device" | "everwatch" | "nightowl" = "everon-device";
}
